import aiSummary from './aiSummary.json';
import livroDeToques from './livroDeToques.json';
import avisosAoCliente from './avisosAoCliente.json';
import textoComVariaveis from './textoComVariaveis.json';
import regrasDeEnvio from './regrasDeEnvio.json';
import pendencias from './pendencias.json';
import perguntasSobreProcesso from './perguntasSobreProcesso.json';
import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import telefonia from './telefonia.json';
import integracoesDoEscritorio from './integracoesDoEscritorio.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import yearInReview from './yearInReview.json';
import appointments from './appointments.json';
import broadcasts from './broadcasts.json';
import internalChats from './internalChats.json';
import commercialAnalysis from './commercialAnalysis.json';
import pipeline from './pipeline.json';
import pipelineWebhooks from './pipelineWebhooks.json';
import followUps from './followUps.json';
import systemHealth from './systemHealth.json';
import leadScore from './leadScore.json';
import whitelabel from './whitelabel.json';
import lumos from './lumos.json';
import legalModule from './legalModule.json';
import legalClientModule from './legalClientModule.json';
import contactRecords from './contactRecords.json';
import financialModule from './financialModule.json';
import correio from './correio.json';
import assinaturas from './assinaturas.json';
import minutas from './minutas.json';

export default {
  ...lumos,
  ...aiSummary,
  ...livroDeToques,
  ...avisosAoCliente,
  ...textoComVariaveis,
  ...regrasDeEnvio,
  ...pendencias,
  ...perguntasSobreProcesso,
  ...legalModule,
  ...contactRecords,
  ...legalClientModule,
  ...financialModule,
  ...correio,
  ...assinaturas,
  ...minutas,
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...pipeline,
  ...pipelineWebhooks,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...telefonia,
  ...integracoesDoEscritorio,
  ...contentTemplates,
  ...mfa,
  ...yearInReview,
  ...appointments,
  ...broadcasts,
  ...internalChats,
  ...commercialAnalysis,
  ...followUps,
  ...systemHealth,
  ...leadScore,
  ...whitelabel,
};
